import React from "react";
import ReactDOM from "react-dom";
import Layout from "./Layout";

// Archivo root de react, muy rara vez se modifica el contenido, para eso existe el layout
ReactDOM.render(
  <React.StrictMode>
    <Layout />
  </React.StrictMode>,
  document.getElementById("root")
);
